/*
 * @Descripttion: 页面插槽管理(左上、右上、左下、右下)
 * @Author: shenah
 * @Date: 2023-06-20 15:34:19
 * @LastEditors: shenah
 * @LastEditTime: 2023-08-14 09:33:27
 */

export default {
  data() {
    return {
      slotAttrBase: ["top-left", "top-right", "bottom-left", "bottom-right"],
    };
  },
  props: {
    isSlotTopLeft: {
      type: Boolean,
      default: false,
    },
    slotTopLeftWidth: {
      type: String,
      default: "100",
    },
    slotTopLeftHeight: {
      type: String,
      default: "60",
    },
    isSlotTopRight: {
      type: Boolean,
      default: false,
    },
    slotTopRightWidth: {
      type: String,
      default: "100",
    },
    slotTopRightHeight: {
      type: String,
      default: "60",
    },
    isSlotBottomLeft: {
      type: Boolean,
      default: false,
    },
    slotBottomLeftWidth: {
      type: String,
      default: "100",
    },
    slotBottomLeftHeight: {
      type: String,
      default: "60",
    },
    isSlotBottomRight: {
      type: Boolean,
      default: false,
    },
    slotBottomRightWidth: {
      type: String,
      default: "100",
    },
    slotBottomRightHeight: {
      type: String,
      default: "60",
    },
  },
  computed: {
    slotTopLeftStyle() {
      return {
        width: this.transPX(this.slotTopLeftWidth),
        height: this.transPX(this.slotTopLeftHeight),
      };
    },
    slotTopRightStyle() {
      return {
        width: this.transPX(this.slotTopRightWidth),
        height: this.transPX(this.slotTopRightHeight),
      };
    },
    slotBottomLeftStyle() {
      return {
        width: this.transPX(this.slotBottomLeftWidth),
        height: this.transPX(this.slotBottomLeftHeight),
      };
    },
    slotBottomRightStyle() {
      return {
        width: this.transPX(this.slotBottomRightWidth),
        height: this.transPX(this.slotBottomRightHeight),
      };
    },
    slotAttrMap() {
      const map = this.slotAttrBase.map((item) => {
        const upperCaseStr = item.split("-").reduce((str, item) => {
          if (!item.length) {
            return str;
          }
          str += item.charAt(0).toUpperCase() + item.slice(1);
          return str;
        }, "");
        const className = "slot-" + item;
        const isDisplay = "isSlot" + upperCaseStr;
        const nameStyle = "slot" + upperCaseStr + "Style";
        const slotName = item;
        return {
          isDisplay: this[isDisplay],
          nameStyle: this[nameStyle],
          className,
          slotName,
        };
      });
      return map;
    },
  },
};
